import { FilterSectionEnum } from '../../enums/filter-section.enum';
import { FilterTypesEnum } from '../../enums/filters-types.enum';
import { IncludeExcludeEnum } from '../../enums/include-exclude.enum';
import { AbstractFilterTypeComponent } from '../..//models/abstract-filter-type.component';
import { CustomFilterTypeModel } from '../../models/custom-filter-type.model';
import { FilterOptionModel } from '../../models/filter-option.model';
import { FilterTypeCheckboxModel } from '../../models/filter-type-checkbox.model';
import { SavedFilter } from '../../models/saved-filter.model';
import { ChipModel } from '../../../Forms/models/chip.model';
import { Type } from '@angular/core';


export interface SavedFilterCard {
    label: string;
    value: SavedFilter;
    filters: SavedFilterDisplayModel[];
    inCompatibleFilters: SavedFilterDisplayModel[];
}

export interface SavedFilterDisplayModel {
    filterName: string;
    includeExclude?: IncludeExcludeEnum;
    chips: ChipModel[];
    type: number | string;
    errorMessage?: string;
    isCompatible?: boolean;
}
export class SavedFilterTypeModel extends FilterTypeCheckboxModel<SavedFilter> implements CustomFilterTypeModel<SavedFilter[]> {

    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    value: SavedFilter[];
    currentValue: SavedFilter[];
    chips: ChipModel[] = [];
    currentChips: ChipModel[] = [];

    filterCards: SavedFilterCard[] = [];
    customComponent: Type<AbstractFilterTypeComponent>;

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        options?: FilterOptionModel<SavedFilter>[],
        value?: SavedFilter[],
        section?: FilterSectionEnum
    ) {
        super(id, label, options, true, null, value, null, null, section);
        this.customComponent = component;

    }
    /**
     * Sets the active value for this filter
     * @param value
     */
    setValue(value: SavedFilter[]): void {
        this.value = value.slice();

        if (this.options && this.value) {
            this.chips = this.value.map((val) => {
                return this.options.find((option) => option.value.id === val.id);
            }).filter(chip => !!chip);
        }

        this.cancelChanges();
    }

    setCurrentValue(value: SavedFilter[]): void {
        this.currentValue = value.slice();

        if (this.options && this.currentValue) {
            this.currentChips = this.currentValue.map((val) => {
                return this.options.find((option) => option.value.id === val.id);
            }).filter(chip => !!chip);
        }

    }

    clear() {
        this.setValue([]);
        this.filterCards = [];
    }

    removeChip(chip: ChipModel): void {
        this.setValue(this.value.filter(valueChip => valueChip.id !== (<any>chip).value.id));
        this.filterCards = this.filterCards.filter(x => x.value.id !== (<any>chip).value.id);
    }

    removeCurrentChip(chip: ChipModel): void {
        this.setCurrentValue(this.value.filter(valueChip => valueChip.id !== (<any>chip).value.id));
        this.filterCards = this.filterCards.filter(x => x.value.id !== (<any>chip).value.id);
    }


    removeFilterCard(card: SavedFilterCard) {
        this.setCurrentValue(this.currentValue.filter(value => value.id !== card.value.id));
        this.filterCards = this.filterCards.filter(x => x.value.id !== card.value.id);
    }


}
